<template>
    <div class="p-3 row">
        <!--<input-text class="col-12 col-md-8" label="Nome do arquivo" v-model="form.nomeArquivo" ref="nome" required/>-->
        <input-date-time class="col-12 col-md-4" label="Data de assinatura" v-model="form.data" ref="data" required/>
        <input-text class="col-12 col-md-4" type="number" :min="0" label="Versão" v-model="form.versao" ref="versao" required/>
        
        <div class="col-12 mb-2">
            <upload 
                    id="contrato"
                    tituloArquivo="Arrastar Arquivo" 
                    selecioneArquivo="Selecionar Arquivo" 
                    type=".*"
                    :arquivo-download="form.conteudoBase64"
                    :arquivo-download-nome="form.nomeArquivoAWS"
                    @upload="(file, nomeArquivo)=> {                   
                        form.nomeArquivoAWS = nomeArquivo;
                        form.conteudoBase64 = file;
                    }" />
        </div>

        <div class="col-12">
            <b-button variant="success" v-if="permissao.c && controles" @click="salvar">
                <i class="fa-solid fa-cloud-upload mr-2"></i>
                Upload do arquivo
            </b-button>
        </div>

        <div class="col-12 mt-3">
            <h6>Lista de arquivos</h6>
            <b-table head-variant="dark" hover :fields="colunas" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="download(data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="controles && permissao.d" class="mr-2" @click="excluir(data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import Upload from '@/components/upload/Upload';

import {FormMixin} from '@/common/mixins/FormMixin';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import ProjetoService from '@/common/services/projeto/projeto.service';

import helpers from '@/common/utils/helpers';

export default {
    name: "ContratoDocumentacao",
    mixins: [FormMixin, AlertasMixin],
    components: {
        InputDateTime,
        InputText,
        Upload,
    },
    props : {
        projetoId : {
            type: String,
            required: true
        },
        projetoIdBase : {
            type: String,
            required: true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        form : {
            nomeArquivoAWS : '',
            conteudoBase64 : '',
            data : null,
            versao : null,
        },
        colunas : [
            { key: "nomeArquivoAWS", label:"Nome do arquivo"},
            { key: "versao", label:"Versão"},
            { key: "data", label:"Data de assinatura",
                formatter: (value) => helpers.formatarDataBr(value)
            },
            { key: "actions", label:"Ações"},
        ],
        itens : [],
    }),
    methods: {
        limpar: function() {
            this.form = {
                nomeArquivoAWS : '',
                conteudoBase64 : '',
                data : null,
                versao : null,
            };
        },
        salvar: function() {
            if(!this.validateState())
                return;

            if(!this.form.conteudoBase64){
                this.alertaErro('Informe o arquivo para salvar');
                return;
            }

            this.confirmar("Deseja realmente salvar o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                let form = this.form;
                form.projetoId = this.projetoIdBase;
                ProjetoService.salvarContratoDocumentacao(form).then(() => {
                    this.alertaSucesso("Arquivo salvo com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao salvar arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao salvar arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },

        excluir: function(id) {
            this.confirmar("Deseja realmente excluir o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                ProjetoService.excluirContratoDocumentacao(id).then(() => {
                    this.alertaSucesso("Arquivo excluido com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao excluir arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao excluir arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },
        buscarArquivos: function() {
            this.$store.dispatch(START_LOADING);
            ProjetoService.listarContratoDocumentacao(this.projetoIdBase).then(res => {
                this.itens = res.data.data.itens;
            }).catch(() => {   
                this.alertaErro(`Erro ao buscar arquivos`);
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        download: function (itemId) {
            this.$store.dispatch(START_LOADING);

            ProjetoService.baixarContratoDocumentacao(itemId)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            })
            .catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            })
            .finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    mounted() {
        this.buscarArquivos();
    },
    computed: {
        controles :function(){
            return this.projetoEditavel;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdContrato');
        },
    }
}
</script>
<style lang="">
    
</style>